import { resolveCurrency, DEFAULT_CURRENCY } from "./view-util.js";

export function parseFlows(text, settings){
  let newFlows = [];
  let currentFlow = null;
  const lines = text.split(/\n/);
  let tmpSettings = { ...settings };
  tmpSettings.showPoints = false;
  tmpSettings.showPrice = false;
  if (!tmpSettings.currency) tmpSettings.currency = DEFAULT_CURRENCY;
  let totalPoints = 0;
  let totalPrice = 0;
  let lastParsed = null;
  let newStory = null;
  let title = null;
  let description = null;
  let allTags = new Set(); // Track all unique tags in the document
  //setSettings(tmpSettings);
  lines.forEach((line, i) => {
    //ignore commented line with "//""
    if (/^\s*\/\//.test(line)) return;
    // capture heading 1
    if (/^#[^#]+/.test(line)) {
      title = line.match(/^#(.+)/)[1];
      lastParsed = "H1";
      // capture heading 2
    } else if (/^##.+/.test(line)) {
      if (currentFlow) newFlows.push(currentFlow);
      currentFlow = {
        name: "New Flow",
        description: "",
        stories: [],
        lineNo: i + 1,
        tags: [], // Add tags array for flows
      };
      
      // Extract tags using curly braces syntax {tag}
      const tagRegex = /{([^}]+)}/g;
      const tagMatches = line.match(tagRegex);
      
      // Remove tags from the name and store them separately
      let flowName = line.match(/^##(.+)/)[1];
      
      if (tagMatches) {
        tagMatches.forEach(tag => {
          // Extract tag without braces
          const tagText = tag.substring(1, tag.length - 1).trim();
          currentFlow.tags.push(tagText);
          allTags.add(tagText); // Add to global set of tags
          
          // Remove the tag from the flow name
          flowName = flowName.replace(tag, '').trim();
        });
      }
      
      currentFlow.name = flowName;
      lastParsed = "H2";
    } else if (/^\w+/.test(line) && lastParsed) {
      if (lastParsed === "H1") description = line;
      else if (lastParsed === "H2")
        if (currentFlow) currentFlow.description = line;
    } else {
      if (/@showPoints/.test(line)) {
        tmpSettings.showPoints = true;
        //setSettings(tmpSettings);
        return;
      } else if (/@showPrice/.test(line)) {
        tmpSettings.showPrice = true;
        //setSettings(tmpSettings);
        return;
      } else if (/@showTable/.test(line)) {
        tmpSettings.showTable = true;
        //setSettings(tmpSettings);
        return;
      } else if (/@pointPrice \d+/.test(line)) {
        const matches = line.match(/@pointPrice (\d+)/);
        if (matches.length === 2) {
          tmpSettings.pointPrice = parseInt(matches[1]);
          //setSettings(tmpSettings);
        }
        return;
      } else if (/@currency\s+\S+/.test(line)) {
        const matches = line.match(/@currency\s+(\S+)/);
        if (matches) {
          tmpSettings.currency = resolveCurrency(matches[1]);
        }
        return;
      } else if (/@dayRate \d+/.test(line)) {
        const matches = line.match(/@dayRate (\d+)/);
        if (matches.length === 2) {
          tmpSettings.dayRate = parseInt(matches[1]);
          //setSettings(tmpSettings);
        }
        return;
      } else if (/@teamSize [\d.]+/.test(line)) {
        const matches = line.match(/@teamSize ([\d.]+)/);
        if (matches.length === 2) {
          tmpSettings.teamSize = parseFloat(matches[1]);
          //setSettings(tmpSettings);
        }
        return;
      } else if (currentFlow && line.length > 0) {
        line = line
          .replace(/\*\*(.*?)\*\*/, "<b>$1</b>")
          //.replace(/\*(.*?)\*/, "<i>$1</i>") //TODO: Why does it delete the flow!?
          .replace(/~~(.*?)~~/, "<strike>$1</strike>")
          .replace(/_(.*?)_/, "<i>$1</i>");
        const lineWithPointsMatches = line.match(
          /^\s*[\*|\-]\s(.+)(\b\d+)pt/
        );
        const lineMatches = line.match(/^\s{0,1}[\*|\-]\s(.+)/);
        const acceptanceCriteriaMatch = line.match(/^(\s{2,4}|\t)\*\s(.+)/);

        if (lineWithPointsMatches || lineMatches) {
          if (newStory) {
            currentFlow.stories.push(newStory);
            newStory = null;
          }
          const matches = lineWithPointsMatches || lineMatches;
          const imgRegex = /#[\w-]+/g;
          const line = matches[1];
          const images = line ? line.match(imgRegex) : [];
          const imageCount = images ? images.length : 1;
          const titleMatches = line.match(/^([^:]+):(.*)/);
          
          var storyText = line
          var titleText = null
          
          if(titleMatches){
            storyText = titleMatches[2]
            titleText = titleMatches[1]
          }// [null, story.text];
          

          // Extract tags from story text using curly braces
          const storyTagRegex = /{([^}]+)}/g;
          const storyTagMatches = storyText.match(storyTagRegex);
          const tags = [];
          
          if (storyTagMatches) {
            storyTagMatches.forEach(tag => {
              const tagText = tag.substring(1, tag.length - 1).trim();
              tags.push(tagText);
              allTags.add(tagText); // Add to global set of tags
              
              // Remove the tag from the story text
              storyText = storyText.replace(tag, '').trim();
            });
          }
          
          newStory = {
            text: storyText,
            title: titleText,
            size: 0,
            acceptanceCriteria: [],
            imageCount: imageCount,
            lineNo: i + 1,
            tags: tags, // Add tags array for stories
            useShortDescription: true, // Enable short descriptions by default
            showFullDescription: false, // Start with short description
            toggleDescription: (story) => {
              story.showFullDescription = !story.showFullDescription;
              // This function will be replaced in UserFlowView with a proper state update function
            }
          };
          if (matches.length === 3) {
            newStory.size = parseInt(matches[2]);
            totalPoints += newStory.size;
            totalPrice = totalPoints * tmpSettings.pointPrice;
          }
        } else if (acceptanceCriteriaMatch && newStory) {
          if (
            acceptanceCriteriaMatch.length === 3 &&
            newStory.acceptanceCriteria
          ) {
            newStory.acceptanceCriteria.push(acceptanceCriteriaMatch[2]);
          }
        }
      }
    }

    if (newStory) {
      currentFlow.stories.push(newStory);
      newStory = null;
    }

    if (i === lines.length - 1 && i !== 0 && currentFlow) {
      newFlows.push(currentFlow);
    }
  });
  return {
    title: title,
    description: description,
    flows: newFlows,
    totalPoints: totalPoints,
    totalPrice: totalPrice,
    settings: tmpSettings,
    allTags: Array.from(allTags) // Convert Set to Array for easier handling
  }
}